export default {"src":"/_next/static/media/assumptions1.677fbc05.svg","height":440,"width":640};